// extracted by mini-css-extract-plugin
module.exports = {"headerOptionTwoWrapper":"headerOptionTwo_headerOptionTwoWrapper__iJzx6","subTitle":"headerOptionTwo_subTitle__ivqqx","description":"headerOptionTwo_description__nVUJM"};